<template>
    <div>
        
        <v-data-table
            :headers="headers"
            :items="itemsProcessed"
            :items-per-page="30"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="primary darken-1 white--text data-table-hourly-data"
            hide-default-footer
        >   
            <template v-slot:header="{}">
                <thead class="white--text" >
                    <th class="th-header" @click="sortDataByDate" >
                        Dia
                        <v-icon v-if="sortDateDesc === false" class="mt-n1 icon-sort-date" small>mdi-arrow-up</v-icon>
                         <v-icon v-else class="mt-n1 icon-sort-date" small>mdi-arrow-down</v-icon>
                    </th>
                    <th class="th-header" @click="sortDataByMinute" >
                        Minuto
                        <v-icon v-if="sortMinuteDesc === false" class="mt-n1 icon-sort-date" small>mdi-arrow-up</v-icon>
                         <v-icon v-else class="mt-n1 icon-sort-date" small>mdi-arrow-down</v-icon>
                    </th>
                    <th class="th-header" :colspan="headers.length - 1">Hora</th>
                </thead>
                <div style="height: 4px;"></div>
            </template> 
            <template v-slot:[`item.date`]="{ item }">
                <v-timeline  class="pr-6 timeline-table" dense>
                    <v-timeline-item 
                        color="primary lighten-1"
                        small
                        fill-dot
                        :hide-dot="!item.highlightDate"
                    >
                        <span v-if="item.highlightDate">{{ item.date }}</span>
                    </v-timeline-item>
                </v-timeline>
            </template>

            <template v-slot:[`item.minute`]="{ item }">
                <v-timeline class="pr-6 timeline-table" dense>
                    <v-timeline-item 
                        color="primary lighten-1"
                        small
                        fill-dot
                    > {{ item.minute }}</v-timeline-item>
                </v-timeline>
            </template>

            <template v-for="(hourKey, index) in hourColumnKeys" v-slot:[`item.hour${hourKey}Value`]="{ item }">
                <observed-sensor-value-table
                    :index="index"
                    :item="item"
                    :hourKey="hourKey"
                    :qualitiesTags="qualitiesTags"
                    :key="index"
                >
                </observed-sensor-value-table>
            </template>

        </v-data-table>
    </div>
</template>

<script>
import ObservedSensorValueTable from "./ObservedSensorValueTable.vue";
export default {
    name: "ObservedTableDataBySensor",
    props:{
        headers:{
            type: Array,
        },
        items:{
            type: Array,
        },
        hourColumnKeys:{
            type: Array,
        },
        qualitiesTags:{
            type: Array,
        },
        showDateWithEmptyData:{
            type: Boolean,
        }
    }, 
    components:{
        ObservedSensorValueTable,
    },
    data: () => ({
        sortDesc: true,
        sortMinuteDesc: true,
        sortDateDesc: true,
        sortBy: 'date',
        itemsProcessed: []
    }),
    watch:{
        items(value){
            if(value){
                this.initialize();
            }
        },
        
        showDateWithEmptyData(value){
            if(value !== undefined){
                this.initialize();
            }
        }
    },
    created(){
        this.initialize();
    },
    methods:{
        initialize(){
            this.itemsProcessed = this.showDateWithEmptyData ? this.items : this.removeDatesWithEmptyValues(this.items)
        },
        removeDatesWithEmptyValues(items){
            const itemsReplaced = [];
            for (const item of items) {
                const verifyItem = Object.assign({}, item);
                const verifyItemAsArray = Object.entries(verifyItem);
                const emptyDates = verifyItemAsArray.filter((entryItem) => {
                    const [ key, value ] = entryItem;
                    return key.includes("Value") && (value || value === 0)
                });
                if(emptyDates.length){
                    itemsReplaced.push(verifyItem);
                }
            }
            return itemsReplaced;
        },
        sortDataByDate(){
            this.sortDateDesc = !this.sortDateDesc;
            this.sortBy = "date";
            this.sortDesc = this.sortDateDesc;
        },
        sortDataByMinute(){
            this.sortMinuteDesc = !this.sortMinuteDesc;
            this.sortBy = "minute"
            this.sortDesc = this.sortMinuteDesc;
        } 
    }
}
</script>

<style scoped>
    .data-table-hourly-data ::v-deep th{
        border-bottom: 1px solid #D9D9D9 !important;
        padding: 0px 20px !important;
        color: #FFFFFF;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
    }

    .data-table-hourly-data ::v-deep td{
       border-bottom: 1px solid #2D324F !important;
        padding: 0px !important;
        font-style: normal;
        font-weight: 500;
        font-size: 14px !important;
        line-height: 18px;
    }
 
    .data-table-hourly-data ::v-deep tr:hover{
        background: var(--v-primary-darken2) !important;
    }

    .data-table-hourly-data ::v-deep .v-data-table__wrapper{
        border-bottom: 1px solid #2D324F !important;
    }

    .timeline-table::before{
        background: #2D324F !important;   
    }

    .th-header{
        border-bottom: 1px solid #D9D9D9 !important;
        text-align: start;
        padding-left: 32px;
        padding-bottom: 8px;
    }

    .icon-sort-date{
        display: none;
    }

    .th-header:hover .icon-sort-date{
        display: inline-block;
    }
</style>